import React from "react";
import { config } from '../config/index';
import { Routes } from '../navigation';
import { StringUtils, DateUtils, StyleUtils, CareOptions, LinkUtils } from '../utils';
import { getItem, setItem } from '../Storage';
import UserController from '../controllers/userController';
import { Player } from '@lottiefiles/react-lottie-player';
import '../css/salient.css';
import '../css/careHome.css';

import care_home_360 from '../images/360-cta-bg.png';
import veterinary    from '../images/veterinary.png';
import video_camera  from '../images/video-camera.png';
import chat_bubble   from '../images/chat-bubble.png';

export default class CareHome extends React.Component {

    constructor(props) {
        super(props);
        // Seed the embark loading flag at construction so the empty-state never
        // flashes before componentDidMount's credits fetch starts.
        let init_partner = getItem('partner');
        let init_user    = getItem('user');
        let init_embark  = init_partner && init_partner.name && init_partner.name.toLowerCase() === 'embark' ? true : false;
        let init_email   = init_user && (init_user.email || (init_user.contact && init_user.contact.email)) ? true : false;
        this.state = {
            embark_training_credits: null,
            loading_embark_credits: init_embark && init_email ? true : false
        };
    }

    componentDidMount = async () => {
        document.body.style.backgroundColor = '#F5F7FB';
        let partner = getItem('partner');
        let partner_name = partner && partner.name ? partner.name : '';
        let is_embark = partner_name && partner_name.toLowerCase() === 'embark';
        let user = getItem('user');
        let user_email = user && user.email ? user.email : '';
            user_email = !user_email && user && user.contact && user.contact.email ? user.contact.email : user_email;

        // Keep live-vs-async chat fresh the same way CareSelection does: providers
        // can come online after landing, so re-pull shortly after mount. Guarded on
        // token+user_id to match CareSelection.repull_available_providers exactly.
        let rp_token   = getItem('token');
        let rp_user_id = getItem('user_id');
        if (rp_token && rp_user_id && this.props.retrieve_online_providers) {
            setTimeout(() => { this.props.retrieve_online_providers(); }, 2000);
        }

        if (is_embark && user_email) {
            let embark_credits_res = await UserController.getEmbarkTrainingCreditsByEmail({ email: user_email, host_name: partner_name });
            let embark_credits_data = embark_credits_res && embark_credits_res.success && embark_credits_res.data && embark_credits_res.data.embarkCredits ? embark_credits_res.data.embarkCredits : null;
            let has_valid_embark_credits = embark_credits_data && (
                embark_credits_data.embark_user_uuid ||
                embark_credits_data._id ||
                typeof embark_credits_data.remainingSessionCount === 'number' ||
                typeof embark_credits_data.has_free_trial_remaining === 'boolean'
            );
            if (has_valid_embark_credits) {
                this.setState({ embark_training_credits: embark_credits_data });
            }
            this.setState({ loading_embark_credits: false });
        } else {
            console.log('CareHome embark training credits response: missing embark partner or email');
        }
    }

    render_consult_button = (type) => {
        let care_options  = this.props.care_options || {};
        let is_video      = type === 'video';
        let is_live_video = type === 'live_video';
        let is_chat       = type === 'chat';

        let button_text = is_chat ? (care_options.show_live_chat ? 'Live Chat' : 'Chat')
                                  : (is_live_video ? 'Live Video' : 'Video');
        let icon        = is_chat ? veterinary : video_camera;
        let consultation_type = is_video ? 'VIDEO'
                              : is_live_video ? 'LIVE_VIDEO'
                              : (care_options.chat_type || 'ASYNC_CHAT');

        return <div className="carehome-consult-card carehome-pressable" key={ type }
                    onClick={ () => {
                        this.props.onTypeChange(consultation_type);
                    }}>
            <div className="carehome-consult-icon">
                <img src={ icon } alt="" />
            </div>
            <div className="carehome-consult-text">
                <span className="carehome-consult-title">{ button_text }</span>
                <span className="carehome-consult-sub">Health</span>
            </div>
        </div>
    }

    render_consult_row = () => {
        let care_options = this.props.care_options || {};
        let cards = [];
        if (care_options.show_video)      { cards.push(this.render_consult_button('video')); }
        if (care_options.show_live_video) { cards.push(this.render_consult_button('live_video')); }
        if (care_options.show_chat)       { cards.push(this.render_consult_button('chat')); }
        if (cards.length === 0) { return null; }
        return <div className="carehome-consult-row">{ cards }</div>;
    }

    get_time_greeting = () => {
        let hour = new Date().getHours();
        if (hour < 12) { return 'Good morning'; }
        if (hour < 18) { return 'Good afternoon'; }
        return 'Good evening';
    }

    render_top_section = () => {
        let user           = getItem('user');
        let partner        = getItem('partner');
        let first_name     = user && user.first_name ? StringUtils.sentenceCase(user.first_name) : '';
        let is_embark      = partner && partner.name && partner.name.toLowerCase() === 'embark' ? true : false;
        let is_halo        = partner && partner.name && partner.name.toLowerCase() === 'halo'   ? true : false;
        let logo_url       = partner && partner.logo_url ? partner.logo_url : '';
        let avatar_initial = first_name ? first_name.charAt(0).toUpperCase() : '';

        return <div className="carehome-hero-wrap">
            <div className={ StyleUtils.get_hero_class('carehome-hero') }>
                <div className="carehome-hero-top">
                    <div className={ StyleUtils.get_logo_chip_class('carehome-hero-logo-chip') }>
                        <img className="carehome-hero-logo" src={ logo_url } alt="" />
                    </div>
                    { avatar_initial ? <div className="carehome-hero-avatar carehome-pressable"
                                            onClick={ () => { if (this.props.profile_action) { this.props.profile_action(); } } }>{ avatar_initial }</div> : null }
                </div>
                <div className="carehome-hero-greeting">
                    <span className="carehome-hero-eyebrow">{ this.get_time_greeting() }</span>
                    <span className="carehome-hero-welcome">{ first_name ? first_name : 'Welcome!' }</span>
                    { !is_halo && <span className="carehome-hero-tagline">Welcome! How can we help you today?</span> }
                </div>
            </div>
            { !is_embark && this.render_consult_row() }
            { is_embark && this.render_training_credits_overlay() }
        </div>
    }

    render_training_credits_overlay = () => {
        let embark_training_credits = this.state.embark_training_credits;
        if (!embark_training_credits) { return null }
        let has_free_trial_remaining = embark_training_credits.has_free_trial_remaining === true;
        let remaining_sessions = embark_training_credits.remainingSessionCount || 0;
        let free_trial_label = has_free_trial_remaining ? 'Free Intro Available' : 'Free Intro Used';

        return <div className="carehome-credits-wrap">
            <div className="carehome-credits-card">
                <div className="carehome-credits-head">
                    <span className="carehome-credits-title">Training Credits</span>
                    <span className={ 'carehome-badge ' + (has_free_trial_remaining ? 'is-positive' : 'is-muted') }>{ free_trial_label }</span>
                </div>
                <div className="carehome-credits-stats">
                    <div className="carehome-stat">
                        <span className="carehome-stat-label">Live Training</span>
                        <span className="carehome-stat-value">{ remaining_sessions }</span>
                        <span className="carehome-stat-foot">Sessions available</span>
                    </div>
                    <div className="carehome-stat">
                        <span className="carehome-stat-label">Intro Phone Call</span>
                        <span className="carehome-stat-value-sm">{ has_free_trial_remaining ? 'Available' : 'Used' }</span>
                        <span className="carehome-stat-foot">{ has_free_trial_remaining ? 'Schedule via SMS' : 'No intro call remaining' }</span>
                    </div>
                </div>
                { remaining_sessions > 0 ? (
                    <div className="carehome-btn-primary carehome-pressable"
                         onClick={ () => { this.props.onTypeChange('TRAINING'); }}>
                        Book Live Training
                    </div>
                ) : (
                    <div className="carehome-btn-primary carehome-pressable"
                         onClick={ () => { LinkUtils.openInNewTab('https://embarkvet.com/'); }}>
                        Add Training Sessions
                    </div>
                ) }
            </div>
        </div>
    }

    render_training_cta = () => {
        let partner       = getItem('partner');
        let is_embark     = partner && partner.name && partner.name.toLowerCase() === 'embark' ? true : false;
        if (is_embark) { return null }   // embark training is surfaced via the credits overlay

        let care_options  = this.props.care_options || {};
        // show_training is the single source of truth; the legacy partner bridge
        // is applied upstream in HomeScreen (see resolve_care_options inputs), so
        // has_any_option / the empty state and this card never disagree.
        if (!care_options.show_training) { return null }

        // Display-only credit counts for legacy partners until partner config
        // supplies them. Remove once config is confirmed for these partners.
        let name              = partner && partner.name ? partner.name.toLowerCase() : '';
        let is_development    = config.ENVIRONMENT && config.ENVIRONMENT.toLowerCase() === 'dev' ? true : false;
        let training_credits  = care_options.training_credits || 0;
        if (name === 'amaze' || name === 'hillsdigestive')            { training_credits = 2; }
        if ((name === 'tailr' || name === 'gps') && is_development)   { training_credits = 1; }

        let credit_gated   = care_options.airtable_access_enabled === true;
        let out_of_credits = credit_gated && training_credits < 1;
        let access_url     = care_options.training_access_url || '';
        let badge_text     = training_credits > 0 ? (training_credits + ' sessions remaining') : 'Book a session';

        return <div className="carehome-section">
            <div className="carehome-train-card" style={{ backgroundImage: `url(${care_home_360})` }}>
                <div className="carehome-train-body">
                    <span className="carehome-train-title">Meet with a professional dog trainer</span>
                    <span className="carehome-train-badge">{ badge_text }</span>
                    { out_of_credits ? (
                        <div className="carehome-btn-light carehome-pressable"
                             onClick={ () => { LinkUtils.openInNewTab(access_url ? access_url : 'mailto:support@teletails.com'); }}>
                            Add credits
                        </div>
                    ) : (
                        <div className="carehome-btn-light carehome-pressable"
                             onClick={ () => { this.props.onTypeChange('TRAINING'); }}>
                            Book your session
                        </div>
                    ) }
                </div>
            </div>
        </div>
    }

    render_360_cta = () => {
        let partner = getItem('partner');
        let care_options = this.props.care_options || {};
        let is_embark = partner && partner.name && partner.name.toLowerCase() === 'embark' ? true : false;
        if (is_embark || !care_options.show_video) { return null }
        return <div className="carehome-section">
            <div className="carehome-row carehome-pressable"
                onClick={ () => {
                    this.props.onTypeChange('VIDEO');
                    this.props.onCategoryChange('wellness');
                }}>
                <div className="carehome-row-icon">
                    <img src={ video_camera } alt="" />
                </div>
                <div className="carehome-row-main">
                    <span className="carehome-row-title">Wellness Check-up</span>
                    <span className="carehome-row-sub">Schedule a review</span>
                </div>
            </div>
        </div>
    }

    render_article_box = (article) => {
        if (!article.title) { return null }

        let title         = article.title;
        let thumbnail_url = article.thumbnail_url;
        let url           = article.url;

        return <div className="carehome-article-card carehome-pressable"
                    onClick={ () => { LinkUtils.openInNewTab(url) }}>
            <img className="carehome-article-img" src={ thumbnail_url } alt="" />
            <div className="carehome-article-body">
                <span className="carehome-article-title">{ title }</span>
            </div>
        </div>
    }

    render_article_section = (article_section) => {
        let section_title = article_section.title;
        let article_1 = article_section && article_section.articles && article_section.articles[0] ? article_section.articles[0] : {};
        let article_2 = article_section && article_section.articles && article_section.articles[1] ? article_section.articles[1] : {};
        return <div className="carehome-section">
            <span className="carehome-section-label">{ section_title }</span>
            <div className="carehome-article-row">
                { this.render_article_box(article_1) }
                { this.render_article_box(article_2) }
            </div>
        </div>
    }

    render_article_sections = () => {

        let articles       = this.props.articles || {};
        let section_titles = Object.keys(articles);
        let article_sections = section_titles.map((section_title) => {
            return {
                title: section_title,
                articles: articles[section_title]
            }
        });

        if (article_sections.length === 0) { return null }

        let article_rows = article_sections.map((article_section) => {
            return this.render_article_section(article_section);
        })

        return <div>
            { article_rows }
        </div>
    }

    render_chat_box = (chat) => {
        let category_str = chat && chat.category ? StringUtils.keyToDisplayString(chat.category) : 'Health';
        let pet_name     = chat && chat.category ? StringUtils.displayName(chat.patient) : '';
        let is_unassigned = chat && chat.category && String(chat.category).toLowerCase() === 'unassigned';
        let title        = is_unassigned ? pet_name : pet_name + ': ' + category_str;
        let preview_text = chat && chat.last_message && chat.last_message.content && chat.last_message.content.text ? chat.last_message.content.text : 'Provider Chat';
            preview_text = preview_text.length > 50 ? preview_text.substring(0, 47) + '...' : preview_text;
        let logged_in_user_id = getItem('user_id');
        let last_msg_sndr_id  = chat && chat.last_message && chat.last_message.from ? chat.last_message.from : '';
        let display_red_dot   = last_msg_sndr_id && last_msg_sndr_id !== logged_in_user_id;
        return <div className="carehome-row carehome-pressable"
                    onClick={ () => {
                        let partner = getItem('partner');
                        let partner_code = partner && partner.code ? partner.code : '';
                        let consult_code = chat    && chat.code    ? chat.code    : '';
                        this.props.navigate(Routes.CHAT + '/' + partner_code + '-' + consult_code);
                    }}>
            <div className="carehome-row-icon">
                <img src={ chat_bubble } alt="" />
            </div>
            <div className="carehome-row-main">
                <span className="carehome-row-title">{ title }</span>
                <span className="carehome-row-sub">{ preview_text }</span>
            </div>
            { display_red_dot && <div className="carehome-row-dot" /> }
        </div>
    }

    render_active_chats = () => {
        let active_chats   = this.props.active_chats || [];
        let filtered_chats = active_chats.filter((chat) => { return chat.status === 'ACTIVE' || chat.status === 'IN_PROGRESS' });

        if (filtered_chats.length === 0) { return null }

        let chat_rows = filtered_chats.map((chat) => {
            return this.render_chat_box(chat);
        });

        return <div className="carehome-section">
            <span className="carehome-section-label">Active Chats</span>
            <div className="carehome-list">
                { chat_rows }
            </div>
        </div>
    }

    has_partner_articles = () => {
        let articles = this.props.articles || {};
        return Object.keys(articles).length > 0;
    }

    // The chat/video CTAs yield to any training surface: the Embark credits
    // overlay or the training card already fill the home screen's empty space.
    displays_training_surface = () => {
        let partner   = getItem('partner');
        let is_embark = partner && partner.name && partner.name.toLowerCase() === 'embark' ? true : false;

        if (is_embark) {
            return this.state.loading_embark_credits || this.state.embark_training_credits ? true : false;
        }

        let care_options = this.props.care_options || {};
        return care_options.show_training === true;
    }

    render_chat_cta = () => {
        let care_options = this.props.care_options || {};
        if (!care_options.show_chat) { return null }
        if (this.has_partner_articles()) { return null }
        if (this.displays_training_surface()) { return null }

        let active_chats   = this.props.active_chats || [];
        let filtered_chats = active_chats.filter((chat) => { return chat.status === 'ACTIVE' || chat.status === 'IN_PROGRESS' });
        if (filtered_chats.length > 0) { return null }

        let is_live_chat = care_options.show_live_chat === true;
        let chat_type    = care_options.chat_type || 'ASYNC_CHAT';
        let subtitle     = is_live_chat ? 'Connect live with a vet expert and get answers in minutes.'
                                        : 'Send a question to a vet expert and hear back soon.';

        return <div className="carehome-section">
            <div className="carehome-chat-cta">
                <div className="carehome-chat-cta-convo">
                    <div className="carehome-chat-cta-line is-user">
                        <div className="carehome-chat-cta-bubble is-accent">My pup keeps scratching his ear...</div>
                    </div>
                    <div className="carehome-chat-cta-line">
                        <div className="carehome-chat-cta-avatar">
                            <img src={ veterinary } alt="" />
                        </div>
                        <div className="carehome-chat-cta-dots">
                            <span /><span /><span />
                        </div>
                    </div>
                </div>
                <span className="carehome-chat-cta-title">Have a question about your pet?</span>
                <span className="carehome-chat-cta-sub">{ subtitle }</span>
                <div className="carehome-chat-cta-foot">
                    <div className="carehome-chat-cta-btn carehome-pressable"
                         onClick={ () => { this.props.onTypeChange(chat_type); }}>Start a Chat</div>
                    <div className="carehome-chat-cta-pet">
                        <Player autoplay loop src={ require('../animations/dog-walking.json') } style={{ height: '95px', width: '95px', marginTop: -18, marginLeft: -10 }} />
                    </div>
                </div>
            </div>
        </div>
    }

    render_video_cta = () => {
        let care_options = this.props.care_options || {};
        if (!care_options.show_video) { return null }
        if (this.has_partner_articles()) { return null }
        if (this.displays_training_surface()) { return null }

        let upcoming = this.props.upcoming_video_consultations || [];
        if (upcoming.length > 0) { return null }

        return <div className="carehome-section">
            <div className="carehome-chat-cta carehome-chat-cta--flip">
                <div className="carehome-video-cta-call">
                    <div className="carehome-chat-cta-avatar">
                        <img src={ video_camera } alt="" />
                    </div>
                    <div className="carehome-video-cta-call-main">
                        <span className="carehome-video-cta-call-name">Vet Expert</span>
                        <span className="carehome-video-cta-call-sub">Ready when you are</span>
                    </div>
                    <div className="carehome-video-cta-live">
                        <div className="carehome-video-cta-live-dot" />
                        LIVE
                    </div>
                </div>
                <span className="carehome-chat-cta-title">See a vet, face to face</span>
                <span className="carehome-chat-cta-sub">Book a video appointment and get expert answers on screen.</span>
                <div className="carehome-chat-cta-foot">
                    <div className="carehome-chat-cta-pet">
                        <Player autoplay loop src={ require('../animations/cat-tail-wag.json') } style={{ height: '120px', width: '120px', marginTop: -32, marginLeft: -22 }} />
                    </div>
                    <div className="carehome-chat-cta-btn carehome-pressable"
                         onClick={ () => { this.props.onTypeChange('VIDEO'); }}>Book a Video</div>
                </div>
            </div>
        </div>
    }

    render_provider_message_box = (thread_chat_consultation) => {
        if (!thread_chat_consultation || !thread_chat_consultation._id) { return null }

        let subject     = thread_chat_consultation.subject || 'Provider Message';
        let pet_name    = thread_chat_consultation.pet_name || '';
            pet_name    = pet_name ? StringUtils.sentenceCase(pet_name) : '';
        let created_at  = thread_chat_consultation.created_at || '';
        let subtitle    = pet_name ? pet_name : '';

        if (!subtitle && created_at) {
            subtitle = DateUtils.getShortMonth(created_at) + ' ' + DateUtils.getDateNumber(created_at) + ', ' + DateUtils.getYear(created_at);
        }

        return <div className="carehome-row carehome-pressable"
                    onClick={ () => {
                        let thread_id = thread_chat_consultation._id;
                        let partner    = getItem('partner');
                        let partner_code = partner && partner.code ? partner.code : '';
                        let thread_code  = thread_chat_consultation && thread_chat_consultation.code ? thread_chat_consultation.code : '';
                        let route_suffix = partner_code && thread_code ? `/${partner_code}-${thread_code}` : '';
                        setItem('thread_chat_consultation_id', thread_id);
                        this.props.navigate(Routes.PROVIDER_MESSAGES + route_suffix, { state: { thread_chat_consultation_id: thread_id, thread_chat_consultation } });
                    }}>
            <div className="carehome-row-icon">
                <img src={ chat_bubble } alt="" />
            </div>
            <div className="carehome-row-main">
                <span className="carehome-row-title">{ subject }</span>
                { subtitle ? <span className="carehome-row-sub">{ subtitle }</span> : null }
            </div>
            { thread_chat_consultation.is_last_message_from_provider === true &&
              <div className="carehome-row-dot" /> }
        </div>
    }

    render_provider_messages = () => {
        let provider_threads = this.props.thread_chat_consultations || [];
        if (!provider_threads || provider_threads.length === 0) { return null }

        let thread_rows = provider_threads.map((thread) => {
            return this.render_provider_message_box(thread);
        });

        return <div className="carehome-section">
            <span className="carehome-section-label">Provider Messages</span>
            <div className="carehome-list">
                { thread_rows }
            </div>
        </div>
    }

    render_upcoming_video_appointment_box = (care_consultation) => {
        let category_str = care_consultation && care_consultation.category ? StringUtils.keyToDisplayString(care_consultation.category) : 'Health';
        let pet_name     = care_consultation && care_consultation.category ? StringUtils.displayName(care_consultation.patient) : '';
        let title        = pet_name + ': ' + category_str;
        let is_training  = care_consultation && care_consultation.is_training ? true : false;

        let time_string    = '';
        let date_string    = '';
        let apt_time       = care_consultation.appointment && care_consultation.appointment.time ? care_consultation.appointment.time : '';
        let sub_tlt_prefix = is_training ? 'Video Training Session' : 'Video Appointment';

        if (apt_time) {
            time_string = DateUtils.getHoursString(apt_time) + ':' + DateUtils.getMinutesString(apt_time) + ' ' + DateUtils.getAMPMString(apt_time);
            date_string = DateUtils.getShortWeekday(apt_time) + ' ' + DateUtils.getShortMonth(apt_time) + ' ' + DateUtils.getDateNumber(apt_time);
        }

        let subtitle = sub_tlt_prefix + ' - ' + date_string + ' - ' + time_string ;
        return <div className="carehome-row carehome-pressable"
            onClick={() => {
                let partner      = getItem('partner');
                let partner_code = partner && partner.code ? partner.code : '';
                let consult_code = care_consultation && care_consultation.code ? care_consultation.code : '';
                this.props.navigate(Routes.APPOINTMENT + '/' + partner_code + '-' + consult_code);
            }}>
            <div className="carehome-row-icon">
                <img src={ video_camera } alt="" />
            </div>
            <div className="carehome-row-main">
                <span className="carehome-row-title">{ title }</span>
                <span className="carehome-row-sub">{ subtitle }</span>
            </div>
        </div>
    }

    render_upcoming_video_appointments = () => {
        let upcoming_video_consultations = this.props.upcoming_video_consultations || [];
        if (upcoming_video_consultations.length === 0) { return null }

        let upcoming_video_consultations_rows = upcoming_video_consultations.map((consultation) => {
            return this.render_upcoming_video_appointment_box(consultation);
        });

        return <div className="carehome-section">
            <span className="carehome-section-label">Upcoming Video Appointments</span>
            <div className="carehome-list">
                { upcoming_video_consultations_rows }
            </div>
        </div>
    }

    render_change_pet = () => {
        if (!this.props.display_change_pet) { return null }
        return <div className="carehome-section">
            <div className="carehome-row carehome-pressable"
                 onClick={ () => { if (this.props.change_pet_action) { this.props.change_pet_action(); } }}>
                <div className="carehome-row-icon">
                    <span className="fas fa-paw" />
                </div>
                <div className="carehome-row-main">
                    <span className="carehome-row-title">Select a different pet</span>
                    <span className="carehome-row-sub">Switch which pet you're booking for</span>
                </div>
            </div>
        </div>
    }

    has_existing_activity = () => {
        let active_chats = (this.props.active_chats || []).filter((c) => c.status === 'ACTIVE' || c.status === 'IN_PROGRESS');
        let threads      = this.props.thread_chat_consultations || [];
        let upcoming     = this.props.upcoming_video_consultations || [];
        return active_chats.length > 0 || threads.length > 0 || upcoming.length > 0;
    }

    render_empty_state = () => {
        // Only a true dead-end (no booking options AND no existing activity) shows
        // the support fallback, so the copy never sits above a user's own chats.
        if (this.has_existing_activity()) { return null }

        let partner = getItem('partner');
        let is_embark = partner && partner.name && partner.name.toLowerCase() === 'embark' ? true : false;

        if (is_embark) {
            // Embark's only entry point is the training-credits overlay. If it is
            // still loading, or did load, defer to it; only when it cannot render
            // (no email / fetch failed) do we offer a support fallback.
            if (this.state.loading_embark_credits || this.state.embark_training_credits) { return null }
        } else if (CareOptions.has_any_option(this.props.care_options)) {
            return null;
        }

        return <div className="carehome-section">
            <div className="carehome-row">
                <div className="carehome-row-main">
                    <span className="carehome-row-title">No care options available</span>
                    <span className="carehome-row-sub">Please contact support@teletails.com</span>
                </div>
            </div>
        </div>
    }

    render() {
        let root_style = {
            '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-grad-start':  StyleUtils.get_header_gradient_start(),
      '--ch-grad-end':    StyleUtils.get_header_gradient_end(),
            '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
            '--ch-button':      StyleUtils.get_button_color(),
            '--ch-button-text': StyleUtils.get_button_text_color_auto(),
            '--ch-primary':     StyleUtils.get_primary_color(),
        };
        return <div className="carehome-root" style={root_style}>
            { this.render_top_section() }

            <div className="carehome-content">
                { this.render_empty_state() }
                { this.render_360_cta() }

                { this.render_active_chats() }
                { this.render_chat_cta() }
                { this.render_provider_messages() }
                { this.render_upcoming_video_appointments() }
                { this.render_video_cta() }

                { this.render_training_cta() }
                { this.render_change_pet() }
                { this.render_article_sections() }
            </div>

            <div style={{ height: 80 }} />
        </div>
    }
}
